import React, { useContext, useState, useEffect } from 'react';
import SummaryTable from './summaryTable';
import printIcon from '../../../images/icons/print-document.svg'; //temp
import { CartContext } from '../../components/Context/cart/CartContext';
import { useTranslation } from 'react-i18next';
import '../../../i18n';
import stoveImg from '../../../images/kamin-default.jpg';
import chimneyImg from '../../../images/skorsten-default.jpg';
import stoveChimneyImg from '../../../images/kamin-skorsten-default.jpg';
import { convertMarketToCurrency } from '../../components/Utils/market';
import { formatNumber } from '../../components/Utils/numbers';
import { useGlobalState } from '../../contexts/GlobalStateContext';
import { convertToLocale } from '../Utils/market';

export default function ConfigSummary({
    config,
    addedToCart,
    history,
    ruleset,
    headerId,
}) {
    const { addProduct } = useContext(CartContext);
    const { globalState } = useGlobalState();
    const { t } = useTranslation();

    const [locale, setLocale] = useState("sv-SE");
    const [currency, setCurrency] = useState("SEK");
    const endConsumerPrice = sessionStorage.getItem('endConsumerPrice') === 'true' ? 'true' : '';

    useEffect(() => {
        if (globalState.activeUserCompany?.market) {
            const custMarket = globalState.activeUserCompany.market.toLowerCase();
            setCurrency(convertMarketToCurrency(custMarket));
            setLocale(convertToLocale(custMarket));
        }
    }, [globalState.activeUserCompany?.market]);

    const ConfigInfoString = (text) => {
        let descriptions = text.split('|');
        return (
            <div>
                {descriptions.map((desc, index) => {
                    return <p key={index}>{desc}</p>;
                })}
            </div>
        );
    };

    const getConfigTitle = (configItem) => {

        if (
            ruleset.match(/^(Stove)$/) &&
            config.ConfigItems.at(-1).Path
        ) {
            //Stove & Chimney
            return `${(locale === "sv-SE" && configItem.Description !== undefined) ? `${configItem.Description} - ${t('cpq-summary.config-title.chimney')}` : t('cpq-summary.config-title.stove-and-chimney')} `
        } else if (ruleset.match(/^(Stove)$/)) {
            return `${(locale === "sv-SE" && configItem.Description !== undefined) ? configItem.Description : t('cpq-summary.config-title.stove')} `
        } else {
            return t('cpq-summary.config-title.chimney');
        }
    };

    const getConfigImage = () => {
        if (
            ruleset.match(/^(Stove)$/) &&
            config.ConfigItems.at(-1).Path
        ) {
            return stoveChimneyImg;
        } else if (ruleset.match(/^(Stove)$/)) {
            return stoveImg;
        } else {
            return chimneyImg;
        }
    };

    /**
     * Chekc if item has a "300-number", that means it's a Contura Stove.
     */
    const getModelName = (configItems) => {
        return configItems.find(item => {
            const num = Number(item.ItemNo); // <-- Use "ItemNo" here
            return !isNaN(num) && num > 300000 && num < 303000;
        });
    }

    let addToCart = () => {
        addProduct({
            image: getConfigImage(),
            title: getConfigTitle(getModelName(config.ConfigItems)),
            sku: config.ConfigId,
            id: config.ConfigId,
            price: endConsumerPrice ? config.ConfiguredPrice * 1.25 : config.ConfiguredPrice,
            items: config.ConfigItems,
            quantity: 1,
            addQty: 1,
            type: 'config',
            headerId: headerId,
            ruleset: ruleset,
        });
        addedToCart();
    };

    let onCancel = () => {
        history.push('/order-add');
    };

    let printSummary = () => {

        window.print();
    };

    return (
        <>
            {config.Status === 'Success' ? (
                <>
                    <div className="cpq-page-content cpq-summary">
                        <div className="cpq-page content">
                            <div className="config-items">
                                <SummaryTable items={config.ConfigItems} endConsumerPrice={endConsumerPrice} currency={currency} locale={locale} />
                                {/* <p className="config-delivery-date"> {deliveryDate && "Leveransdatum: " + deliveryDate}</p> */}
                                <img
                                    className="print-icon"
                                    src={printIcon}
                                    alt="Print"
                                    onClick={printSummary}
                                />
                            </div>

                            {config.ConfigItems.at(-1).Path &&
                                config.ConfigItems.at(-1).ConfigInfoStr ? (
                                <div className="config-description">
                                    <img
                                        src={config.ConfigItems.at(-1).Path}
                                        alt="Configuration description"
                                    />
                                    <div className="config-info-string">
                                        {ConfigInfoString(
                                            config.ConfigItems.at(-1)
                                                .ConfigInfoStr
                                        )}
                                    </div>
                                </div>
                            ) : null}
                        </div>

                    </div>
                    <div className="cpq-footer">

                        <div className="cpq-footer-buttons">
                            <button
                                onClick={onCancel}
                                className="button-submit button-tertiary">
                                {t('cpq.cancel')}
                            </button>

                            <button
                                onClick={addToCart}
                                className="button-submit button-primary">
                                {t('cpq.add-to-cart')}
                            </button>

                        </div>

                        <p className="cpq-price">
                            <span className="cpq-price-details">
                                <span className="cpq-price-label">{t('cpq-summary.sum')}</span>
                                <span className="cpq-price-value">
                                    {endConsumerPrice ? formatNumber((config.ConfiguredPrice * 1.25), currency, locale) : formatNumber(config.ConfiguredPrice, currency, locale)}
                                </span>
                            </span>

                        </p>
                    </div>
                </>
            ) : (
                <div>
                    <h3>
                        {t('cpq-summary.configuration-error')}
                        {config.Status} |
                        {config.Error}
                    </h3>
                </div>
            )}
        </>
    );
}
